export interface IDocusignRedirectRequest {
        envelopeRemoteId: string;
    }

    export class DocusignRedirectRequest implements IDocusignRedirectRequest {
        envelopeRemoteId: string;

        constructor(envelopeRemoteId: string) {
            this.envelopeRemoteId = envelopeRemoteId;
        }
    }